module.exports = __webpack_public_path__ + "static/media/paw-alt.7c7a5f88.svg";